export const hasRole = (role: number, userRoles: Array<number>): boolean => userRoles.indexOf(role) !== -1;
